export const agMemberTabs = [
  { label: "Details", value: "details" },
  // { label: "Family", value: "family" },
];


export const formState = {
  "dn_city": "97",
  "dn_name": "NA",
  "dn_type": "Hospital",
  "dn_state": "79",
  "dn_city_1": "97",
  "dn_gender": "535",
  "dn_mobile": null,
  "dn_pincode": 425002,
  "dn_state_1": "79",
  "dn_corraddr": "29 Jai Nagar, Second Lane, Behind Hotel Royal Palace, Jalgaon",
  "dn_firsname": "Sameer Chanchal",
  "dn_highqual": "238",
  "dn_hospaddr": "NA",
  "dn_lastname": "Shah",
  "dn_mobialte": "",
  "dn_ownership": "Own",
  "dn_pincode_1": 0,
  "dn_dateofbirt": "1973-12-21 05:30:00.000000",
  "dn_emaiidalte": "drchanchalshah73@gmail.com",
  "dn_emaiidprim": null,
  "dn_numbofbeds": 0,
  "dn_pracsinc_1": null,
  "dn_imabranname": "151",
  "dn_imareginumb": "MAH/18148/44/173/154537/2010-11/CL",
  "dn_collnamembbs": "M.G.M. Medical College Indore",
  "dn_apprcounofempl": null,
  "dn_currdesiinima_1": "544",
  "dn_pastdesiinima_1": "544",
  "dn_spechighqualifothe": ""
};